module.exports = __webpack_public_path__ + "img/close.6f3fbd25.png";